import { render, staticRenderFns } from "./OfferCalendarDetailsComponent.vue?vue&type=template&id=8332ca3e&scoped=true"
import script from "./OfferCalendarDetailsComponent.vue?vue&type=script&lang=js"
export * from "./OfferCalendarDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./OfferCalendarDetailsComponent.vue?vue&type=style&index=0&id=8332ca3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8332ca3e",
  null
  
)

export default component.exports